export default __webpack_public_path__ + "static/media/product4.aa3409e8.png";